export interface AnnualEIT101010List {
    row?: string,
    name?: string,
    amount?: string,
    indent?: number,
    rowspan?: number,
    isEdit?: boolean,
    type?: string,
}

let list: AnnualEIT101010List[] = [
    {
        name: "一、营业收入（2+9）",
        row: "1",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "（一）主营业务收入（3+5+6+7+8）",
        row: "2",
        amount: "",
        indent: 0,
        isEdit: false,
        type:"",
    },
    {
        name: "1.销售商品收入",
        row: "3",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "其中：非货币性资产交换收入",
        row: "4",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "2.提供劳务收入",
        row: "5",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "3.建造合同收入",
        row: "6",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "4.让渡资产使用权收入",
        row: "7",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "5.其他",
        row: "8",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "（二）其他业务收入（10+12+13+14+15）",
        row: "9",
        amount: "",
        indent: 0,
        isEdit: false,
        type:"",
    },
    {
        name: "1.销售材料收入",
        row: "10",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "其中：非货币性资产交换收入",
        row: "11",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "2.出租固定资产收入",
        row: "12",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "3.出租无形资产收入",
        row: "13",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "4.出租包装物和商品收入",
        row: "14",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "5.其他",
        row: "15",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "二、营业外收入（17+18+19+20+21+22+23+24+25+26）",
        row: "16",
        amount: "",
        indent: 0,
        isEdit: false,
        type:"",
    },
    {
        name: "（一）非流动资产处置利得",
        row: "17",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "（二）非货币性资产交换利得",
        row: "18",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "（三）债务重组利得",
        row: "19",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "（四）政府补助利得",
        row: "20",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "（五）盘盈利得",
        row: "21",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "（六）捐赠利得",
        row: "22",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "（七）罚没利得",
        row: "23",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "（八）确实无法偿付的应付款项",
        row: "24",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "（九）汇兑收益",
        row: "25",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },
    {
        name: "（十）其他",
        row: "26",
        amount: "",
        indent: 0,
        isEdit: true,
        type:"",
    },


]


let AnnualEIT101010 = list
export default AnnualEIT101010
